var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortSearch',{attrs:{"default-sort":"featured","dimension":"FeaturedVectors"}})
}
var staticRenderFns = []

export { render, staticRenderFns }